import axios from 'axios';
import { CornerToCornerApiResponse, CornerToCorner, CornerToCornerDetailApiResponse, CornerToCornerDetailByTickerAndCandlestickApiResponse } from '../interfaces/corner_to_corner';

export const fetchCornerToCornerData = async (page: number = 1): Promise<CornerToCornerApiResponse> => {
  
  const response = await axios.get<CornerToCornerApiResponse>('https://api.diwo.capital/v1/corner_to_corner', {
    params: {
      page: page
    }
  });

  return {
    data: response.data.data,
    total: response.data.total,
    timestamp: response.data.timestamp
  };
};

export const fetchCornerToCornerDetail = async (id: number): Promise<CornerToCorner> => {
    const response = await axios.get<CornerToCornerDetailApiResponse>(`https://api.diwo.capital/v1/corner_to_corner/${id}`);
    return response.data.data;
}; 


export const fetchCornerToCornerDetailByTickerAndCandlestick = async (id_ticker: number, id_candlestick: number): Promise<CornerToCornerDetailByTickerAndCandlestickApiResponse> => {
    const response = await axios.get<CornerToCornerDetailByTickerAndCandlestickApiResponse>(`https://api.diwo.capital/v1/corner_to_corner/${id_ticker}/${id_candlestick}`);
    return response.data;
}; 